module.exports = __webpack_public_path__ + "static/img/mail.598d07e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mail.png
// module id = pUv8
// module chunks = 0